(function () {
  'use strict';

  const SUPPORTED = ['en', 'de', 'cs', 'fr', 'sk'];

  // Source button injected by the Wishlist Hero App
  const ORIGINAL_SELECTOR =
    '.wishlisthero-product-page-button-container button';

  const LABELS = {
    idle: {
      en: 'Add to wishlist',
      de: 'Zur Merkliste',
      cs: 'Přidat do seznamu přání',
      fr: 'Ajouter à la liste de souhaits',
      sk: 'Pridať do zoznamu želaní',
    },
    added: {
      en: 'Added to wishlist',
      de: 'Zur Merkliste hinzugefügt',
      cs: 'Přidáno do seznamu přání',
      fr: 'Ajouté à la liste de souhaits',
      sk: 'Pridané do zoznamu želaní',
    },
  };

  // DOM — Liquid-rendered, guaranteed at script run

  const myLabel = document.getElementById('product-wishlist-cta');
  const myButton = document.getElementById('wishlist-cta');

  if (!myLabel || !myButton) return;


  //get language

  function getPageLanguage() {
    const { hostname, pathname } = window.location;
    const pathLang = pathname.split('/').filter(Boolean)[0];

    if (SUPPORTED.includes(pathLang)) return pathLang;

    if (hostname.endsWith('.de')) return 'de';
    if (hostname.endsWith('.fr')) return 'fr';
    if (hostname.endsWith('.sk')) return 'sk';
    if (hostname.endsWith('.cz')) return 'cs';

    return 'en';
  }

  const lang = getPageLanguage();


  function isInWishlist(originalButton) {
    return originalButton.classList.contains(
      'wishlisthero-product-in-wishlist'
    );
  }

  function sync(originalButton) {
    const isActive = isInWishlist(originalButton);
    myLabel.textContent = isActive ? LABELS.added[lang] : LABELS.idle[lang];
    myButton.setAttribute('aria-pressed', String(isActive));
  }

  function attachTo(originalButton) {
    myButton.addEventListener('click', () => originalButton.click());

    sync(originalButton); // reflect whatever state it's already in

    const stateObserver = new MutationObserver(() => sync(originalButton));
    stateObserver.observe(originalButton, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    const existing = document.querySelector(ORIGINAL_SELECTOR);
    if (existing) {
      attachTo(existing);
      return;
    }

    const domObserver = new MutationObserver(() => {
      const button = document.querySelector(ORIGINAL_SELECTOR);
      if (button) {
        domObserver.disconnect();
        attachTo(button);
      }
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  init();
})();